import { hasPermission } from '@dcc-erp/shared';

import { useActiveCompanyId, useMe } from '../queries';

// UX-only permission check (server still enforces via @RequirePermission).
export function usePermissions() {
  const companyId = useActiveCompanyId();
  const { data: me } = useMe(companyId);
  const held = me?.permissions ?? [];
  return {
    permissions: held,
    roles: me?.roles ?? [],
    can: (required: string) => hasPermission(held, required),
  };
}
